module.exports = __webpack_public_path__ + "static/media/Wind.7e0c0db2.mp3";